import { ref } from 'vue';
import type { DebitorAccount, Member } from '@/models/member';

// Module-level refs — shared across all composable calls, never serialised to localStorage or Pinia
const currentUser = ref<Member | undefined>();
const currentDebitor = ref<DebitorAccount | undefined>();

// sessionStorage key — stores only the debitor number string, never sensitive data
const DEBITOR_SESSION_KEY = 'lastDebitorNumber';

export function useSession() {
    function setCurrentUser(user: Member | undefined) {
        currentUser.value = user;
    }

    function setCurrentDebitor(account: DebitorAccount | undefined) {
        currentDebitor.value = account;
        if (account) {
            sessionStorage.setItem(DEBITOR_SESSION_KEY, account.debitorNumber);
        } else {
            sessionStorage.removeItem(DEBITOR_SESSION_KEY);
        }
    }

    function clearSession() {
        currentUser.value = undefined;
        currentDebitor.value = undefined;
        sessionStorage.removeItem(DEBITOR_SESSION_KEY);
    }

    return { currentUser, currentDebitor, setCurrentUser, setCurrentDebitor, clearSession };
}
